/**
 * Pick random element.
 * @param {Array} arr - array of elements
 * @returns random element of an array.
 */
function randomElement(arr) {
	if (!(arr instanceof Array)) throw `Argument ${arr} is not an array`;
	var index = Math.floor(arr.length * Math.random());
	return arr[index];
}

module.exports = randomElement;